module.exports = __webpack_public_path__ + "favicon.png?b86961372a102394cad6e0dd9e7c8437";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon.png
// module id = 133
// module chunks = 0